import React, { Component, useState } from "react";
import { useLocation } from 'react-router-dom';
import axios from "axios"
import PhoneInput from 'react-phone-input-2'
import 'react-phone-input-2/lib/style.css'
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
//import SimpleModal from '../../components/SimpleModal/SimpleModal';

class HRAnonHotlineForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            name: '',
            email: '',
            phoneState: '',
            phone: '',
            subject: '',
            location: '',
            comment: '',
            submittedstate: 'not-submitted'
        };
        this.locations = [
            'Please Select',
            'Playa Vista',
            'Burbank',
            'New York',
            'London',
            'Singapore',
            'Remote',
            'I\'d rather not say'
        ];
        this.messages = {
            success: {
                header: `Submission successful`,
                body: `A member of the HR Team will investigate your submission.`
            },
            fail: {
                header: 'Sorry, there is something wrong on our end',
                body: 'Please try again later.'
            }
        };
    }

    formPageContent() {
        return (
            <div className="col-sm-8 col-sm-offset-4">
                <h1>People Operations Anonymous Hotline</h1>
                <p>Anything you report will be investigated by a member of the People Operations team. If you wish to be contacted about your submission, please include your name and contact information. Please be as detailed as possible in your submission.</p>
                <form id="erase-my-data-form" className="form-horizontal" onSubmit={this.handleSubmit.bind(this)}>
                    <div className="form-group">
                        <label htmlFor="input-name" className="col-sm-4 control-label">Name (optional)</label>
                        <div className="col-sm-8">
                            <input type="text" className="form-control" id="input-name" placeholder="" value={this.state.name} onChange={this.onSimpleInputChange.bind(this)} />
                        </div>
                    </div>
                    <div className="form-group">
                        <label htmlFor="input-email" className="col-sm-4 control-label">Email (optional)</label>
                        <div className="col-sm-8">
                            <input
                                type="email"
                                className="form-control"
                                id="input-email"
                                placeholder="name@example.com"
                                value={this.state.email}
                                onChange={this.onSimpleInputChange.bind(this)}
                                pattern="[^@\s]+@[^@\s]+\.[^@\s]+"
                            />
                        </div>
                    </div>
                    <div className="form-group">
                        <label htmlFor="input-phone" className="col-sm-4 control-label">Phone number (optional)</label>
                        <div className="col-sm-8">
                            <PhoneInput
                                country={'us'}
                                value={this.state.phoneState}
                                onChange={this.handlePhoneOnChange.bind(this)}
                                preferredCountries={['us']}
                                placeholder="Enter your phone number"
                                inputStyle={{ 'width': '100%' }}
                                inputProps={{ required: false }}
                            />
                        </div>
                    </div>
                    <div className="form-group">
                        <label htmlFor="input-subject" className="col-sm-4 control-label">Subject Matter</label>
                        <div className="col-sm-8">
                            <input type="text" className="form-control" id="input-subject" placeholder="" value={this.state.study} onChange={this.onSimpleInputChange.bind(this)} required />
                        </div>
                    </div>
                    <div className="form-group">
                        <label htmlFor="input-location" className="col-sm-4 control-label">Location (optional)</label>
                        <div className="col-sm-8">
                            <select id="input-location" className="btn btn-default" style={{ width: '100%' }} onChange={this.onSimpleInputChange.bind(this)}>
                                {this.locations.map(location => <option value={location} key={location}>{location}</option>)}
                            </select>
                        </div>
                    </div>
                    <div className="form-group">
                        <label htmlFor="input-comment" className="col-sm-4 control-label">Comments</label>
                        <div className="col-sm-8">
                            <textarea className="form-control" id="input-comment" placeholder="Please provide as much detail as possible" value={this.state.typeofrequest} onChange={this.onSimpleInputChange.bind(this)} required />
                        </div>
                    </div>
                    <div className="form-group">
                        <div className="col-sm-offset-10 col-sm-2">
                            <button type="submit" className="btn btn-default">Submit</button>
                        </div>
                    </div>
                </form>
            </div>
            );
    }

    render() {
        let contents = this.formPageContent();
        if (this.state.submittedstate !== 'not-submitted') {
            let innerContent = this.state.submittedstate === 'submitted-success' ? this.messages.success : this.messages.fail;
            contents = <div className="col-sm-8 col-sm-offset-4">
                <h3>{innerContent.header}</h3>
                <p>{innerContent.body}</p>
            </div>;
        }
        return (
            <div className={[this.page, "container-fluid"].join(" ")}>
                <div className="row">
                    {contents}
                </div>
            </div>
        );
    }

    handlePhoneOnChange(value, data, event, formattedValue) {
        this.setState({ phoneState: value });
        this.setState({ phone: formattedValue });
    }

    onSimpleInputChange(event) {
        switch (event.target.id) {
            case 'input-name':
                this.setState({ name: event.target.value });
                break;
            case 'input-email':
                this.setState({ email: event.target.value });
                break;
                break;
            case 'input-subject':
                this.setState({ subject: event.target.value });
                break;
            case 'input-location':
                this.setState({ location: event.target.value });
                break;
            case 'input-comment':
                this.setState({ comment: event.target.value });
                break;
        }
    }


    resetForm() {
        this.setState({
            name: '',
            email: '',
            phone: '',
            subject: '',
            location: '',
            comment: ''
        });
    }

    handleSubmit(e) {
        e.preventDefault();
        axios({
            method: "POST",
            url: "api/Home/SubmitAnonHotlineForm",
            data: JSON.stringify(this.state),
            headers: {
                'content-type':'application/json'
            }
        }).then((response) => {
            if (response.status == 200) {
                this.setState({ submittedstate: 'submitted-success' })
                this.resetForm();
            } else {
                this.setState({ submittedstate: 'submitted-error' })
            }
        }).catch((error) => {
            console.error(error);
            this.setState({ submittedstate: 'submitted-error' })
        })
    }
}

export default HRAnonHotlineForm;